<template>

  <section class="panel-video">
    <div class="section" id="Demo">           
            <div class="overlay">
                <div class="container">
                    <div class="text-center">
                        <h2 class="text-white">Comment acheter <br> un billet sur Skanticket ?</h2>
                        <p class="mb-5">Cette video vous explique les differentes etapes pour l’achat d’un ticket</p>
    
                        <a href="#" id="btnPlay" class="text-white" data-toggle="modal" data-target="#demoVideoModal">
                            <i class="fa text-block fa-5x fa-play-circle text-white" aria-hidden="true"></i>
                            <br> Lire
                        </a>
                    </div>
                </div>
            </div>
            <!-- Modal -->
            <div class="modal fade " id="demoVideoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="modal-title">Acheter un ticket sur Skanticket</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                            <iframe style="width: 100%" height="480" src="https://www.youtube.com/embed/hCoefigFcw8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
                </div>
            </div>
        </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'panel-video',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  #Demo{
    background: url(../assets/img/using_skanticket_bg.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size:cover;
    position: relative;
    padding: 0;
  }

  #Demo h2{
    font-size: 3.5em;
  }

  #Demo .overlay{
      top: 0;
      padding: 7em 0;
      width: 100%;
      height: 100%;
      background: rgba(252, 184, 41, .9);
  }

  #demoVideoModal .modal-header{
      padding: .2rem 1rem;
      background: var(--sk-darkblue);
      color: #fff;
      border-bottom: 0;
  }

  #demoVideoModal .modal-content{
      background: transparent !important;
      border: 0;
  }

  #demoVideoModal .modal-body{
      padding: 0;
  }

  #demoVideoModal .modal-header h5{
      font-size: 1em;
  }

  #btnPlay:hover{
      text-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
  }
</style>
